<template>
  <v-container grid-list-md fluid text-xs-center>
    <v-layout row wrap>
      <v-flex xs12>
        <v-toolbar
          tabs
          scroll-target="#scrolling-activity"
          style="z-index: 1; padding-bottom: 10px"
        >
          <v-layout row wrap>
            <v-flex xs6 sm3 md3 lg6>
              <v-toolbar-title
                style="text-align: left; top: 10px; position: relative"
                >Rondas</v-toolbar-title
              >
            </v-flex>

            <v-flex xs6 sm9 md9 lg6 justify-end class="titleSearch">
              <v-layout row wrap>
                <v-flex xs9 sm9 md9 lg9>
                  <v-text-field
                    flat
                    label="Buscar"
                    append-outer-icon="search"
                    clearable
                    solo-inverted
                    hide-details
                    @click:append-outer="filterSearch(false)"
                    @click:clear="clearSearch"
                    @keyup.enter="filterSearch(false)"
                    v-model="search"
                  />
                </v-flex>
                <v-flex xs3 sm3 md3 lg3>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-if="
                          userPermissions[
                            possibleUserModulePermissions.DELETE_ROUNDS
                          ]
                        "
                        icon
                        :disabled="selected.length > 0 ? false : true"
                        @click="deleteRound()"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon
                          :color="selected.length > 0 ? 'primary' : 'grey'"
                        >
                          delete
                        </v-icon>
                      </v-btn>
                    </template>

                    <span>Eliminar ronda</span>
                  </v-tooltip>
                </v-flex>
              </v-layout>
            </v-flex>

            <v-speed-dial
              key="1"
              absolute
              bottom
              left
              direction="bottom"
              open-on-hover
              transition="scale-transition"
              style="bottom: 0"
            >
              <template v-slot:activator>
                <v-btn color="gradiente" dark fab>
                  <v-icon>more_vert</v-icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
              </template>
              <v-tooltip right>
                <v-btn
                  fab
                  dark
                  small
                  color="gradiente"
                  slot="activator"
                  @click="downloadPdf"
                >
                  <v-icon>file_download</v-icon>
                </v-btn>
                <span>Descargar PDF</span>
              </v-tooltip>
              <v-tooltip right>
                <v-btn
                  fab
                  dark
                  small
                  color="gradiente"
                  slot="activator"
                  @click="downloadXlsx"
                >
                  <v-img
                    :style="{ flex: '0 1 auto' }"
                    height="28px"
                    width="28px"
                    :src="require('@/assets/reports/IconoCSV.png')"
                  />
                </v-btn>
                <span>Descargar XLSX</span>
              </v-tooltip>
            </v-speed-dial>
          </v-layout>
        </v-toolbar>
        <!-- <div style="witdh: 100%; height: 50px" v-if="btnClearFilters"></div> -->
        <v-container fluid elevation-2 class="scrollDesign table-full">
          <v-layout row wrap>
            <v-flex xs12>
              <v-data-table
                v-model="selected"
                item-key="id"
                select-all
                ref="table"
                :headers="headers"
                :items="rounds"
                :pagination.sync="pagination"
                :rows-per-page-items="[25, 50, 100]"
                :total-items="totalRounds"
                :loading="working.loading"
                :no-data-text="working.loading ? 'Cargando' : 'No hay rondas'"
                rows-per-page-text="Registros por página"
                :no-results-text="
                  working.loading ? 'Cargando' : 'No se encontraron resultados'
                "
                :expand="expand"
                must-sort
              >
                <template v-slot:pageText="props"
                  >{{ props.pageStart }} - {{ props.pageStop }} de
                  {{ props.itemsLength }}</template
                >
                <template v-slot:headers="props">
                  <tr>
                    <th
                      v-if="
                        userPermissions[
                          possibleUserModulePermissions.DELETE_ROUNDS
                        ]
                      "
                      class="text-xs-left"
                      style="width: 80px; max-width: 80px; min-width: 80px"
                    >
                      <v-checkbox
                        :input-value="props.all"
                        :indeterminate="props.indeterminate"
                        primary
                        color="primary"
                        hide-details
                        @click.stop="toggleAll"
                      ></v-checkbox>
                    </th>
                    <th
                      v-for="header in props.headers"
                      :key="header.text"
                      :style="header.style"
                      :class="[
                        header.sortable ? 'sortable_pick' : '',
                        'text-xs-left',
                      ]"
                      @click="header.sortable ? changeSort(header.value) : null"
                    >
                      {{ header.text }}
                      <SortTableArrow
                        :hide="header.sortable === false"
                        :is-active="header.value === pagination.sortBy"
                        :is-upward="pagination.descending"
                      />
                    </th>
                  </tr>
                </template>
                <template v-slot:items="props">
                  <td
                    v-if="
                      userPermissions[
                        possibleUserModulePermissions.DELETE_ROUNDS
                      ]
                    "
                    class="text-xs-left"
                    style="width: 80px; max-width: 80px; min-width: 80px"
                  >
                    <v-checkbox
                      color="primary"
                      v-model="props.selected"
                      primary
                      hide-details
                    ></v-checkbox>
                  </td>
                  <td
                    class="text-xs-left"
                    style="width: 80px; max-width: 80px; min-width: 80px"
                  >
                    <v-avatar
                      size="30px"
                      color="grey lighten-4"
                      v-if="
                        props.item.imageStorage &&
                        props.item.imageStorage.miniObjUrl
                      "
                    >
                      <img
                        :src="props.item.imageStorage.miniObjUrl"
                        alt="avatar"
                      />
                    </v-avatar>
                    <v-icon v-else>account_circle</v-icon>
                  </td>
                  <td
                    class="text-xs-left"
                    style="width: 200px; max-width: 200px; min-width: 200px"
                  >
                    {{ props.item.name }}
                  </td>
                  <td
                    class="text-xs-left"
                    style="width: 175px; max-width: 175px; min-width: 175px"
                  >
                    {{ props.item.createdAt | formatDateA }}
                  </td>
                  <td
                    class="text-xs-left"
                    style="width: 200px; max-width: 200px; min-width: 200px"
                  >
                    <span>{{
                      props.item.roundType === 'EVENTUAL'
                        ? 'Eventual'
                        : 'Por siempre'
                    }}</span>
                  </td>
                  <td
                    class="text-xs-left"
                    style="width: 200px; max-width: 200px; min-width: 200px"
                  >
                    <v-chip v-if="props.item.status == 'A'">
                      <v-avatar>
                        <v-icon color="green">check_circle</v-icon> </v-avatar
                      >Autorizado
                    </v-chip>
                    <v-chip v-else-if="props.item.status == 'C'">
                      <v-avatar> <v-icon color="red">cancel</v-icon> </v-avatar
                      >No autorizado
                    </v-chip>
                    <v-chip v-if="props.item.status == 'P'">
                      Autorización pendiente
                    </v-chip>
                  </td>
                  <td class="text-xs-left" style="width: 100%">
                    <v-chip readonly>
                      <v-avatar>
                        <img
                          :src="props.item.parent.imageStorage.miniObjUrl"
                          alt="alt"
                          v-if="
                            props.item.parent.imageStorage != null &&
                            props.item.parent.imageStorage.miniObjUrl
                          "
                        />
                        <v-icon v-else>account_circle</v-icon>
                      </v-avatar>
                      {{
                        props.item.parent.firstName +
                        ' ' +
                        props.item.parent.lastName
                      }}
                    </v-chip>
                  </td>
                  <td
                    class="text-xs-left"
                    style="width: 120px; max-width: 120px; min-width: 120px"
                    @click="props.expanded = !props.expanded"
                  >
                    <v-btn icon>
                      <v-badge
                        :color="props.item.invitations.length ? 'green' : 'red'"
                      >
                        <template v-slot:badge>
                          <span>{{ props.item.invitations.length }}</span>
                        </template>
                        <v-icon class="no-border">
                          {{
                            !props.item.invitations.length
                              ? 'person_outline'
                              : props.item.invitations.length == 1
                              ? 'person'
                              : 'group'
                          }}
                        </v-icon>
                      </v-badge>
                    </v-btn>
                  </td>
                  <td
                    class="text-xs-left"
                    style="width: 250px; max-width: 250px; min-width: 250px"
                    v-if="
                      props.item.status == 'P' &&
                      userPermissions[
                        possibleUserModulePermissions.CONFIRM_ROUNDS
                      ]
                    "
                  >
                    <v-tooltip left>
                      <v-btn
                        @click="confirmRound(props.item, true)"
                        icon
                        slot="activator"
                      >
                        <v-icon color="green">check_circle</v-icon>
                      </v-btn>
                      <span>Autorizar</span>
                    </v-tooltip>
                    <v-edit-dialog
                      id="cancelRound"
                      class="mr-3"
                      :return-value.sync="description"
                      lazy
                      small
                      @save="confirmRound(props.item, false, description)"
                      @cancel="description = ''"
                      @close="description = ''"
                      save-text="Aceptar"
                      cancel-text="Cancelar"
                    >
                      <v-tooltip left>
                        <v-btn slot="activator" icon>
                          <v-icon color="red">cancel</v-icon>
                        </v-btn>
                        <span>Denegar</span>
                      </v-tooltip>
                      <template v-slot:input>
                        <v-text-field
                          v-model="description"
                          label="Motivo"
                        ></v-text-field>
                      </template>
                    </v-edit-dialog>
                  </td>
                  <td
                    class="text-xs-left"
                    v-else
                    style="width: 230px; max-width: 230px; min-width: 230px"
                  ></td>
                </template>
                <template v-slot:expand="props">
                  <RoundStudents
                    :userPermissions="userPermissions"
                    :invitations="props.item.invitations"
                    :round="props.item"
                    @onDelete="onDeleteInvitation"
                  ></RoundStudents>
                  <v-divider></v-divider>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
    <desition
      @desition="$event ? onDeleteRound() : ''"
      v-model="modals.confirmDelete"
      title="Eliminar ronda"
      :description="
        selected.length == 1 ? msgDeleteRoundOne : msgDeleteRoundSome
      "
    />
    <success v-model="toast.success" text="Operación exitosa"></success>
    <error v-model="toast.failed" text="Ups! ocurrió un error"></error>
    <loading v-model="working.loading" text="Trabajando"></loading>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import {
  _genericDownloadFile,
  _getUserPermissions,
} from '../../../../../utils/genericUtils.js'
import desition from '../../../../Dialogs/Confirm.vue'
import error from '../../../../Dialogs/Error.vue'
import loading from '../../../../Dialogs/Loading.vue'
import success from '../../../../Dialogs/Success.vue'
import RoundStudents from '../../../../Sections/Rounds/Round-Invitations.vue'
import SortTableArrow from '../../../../Tools/SortTableArrow.vue'

export default {
  components: {
    RoundStudents,
    success,
    loading,
    error,
    loading,
    desition,
    SortTableArrow,
  },
  mounted() {
    if (this.getUser != null && this.getUser.id) {
      this.mapPermits()
      if (
        !this.userPermissions[this.possibleUserModulePermissions.WATCH_ROUNDS]
      ) {
        this.toast.failed = true
      } else {
        if (this.rounds.length == 0) {
          this.getRounds()
        }
      }
    }
  },
  data: () => ({
    msgDeleteRoundOne:
      'Esta acción es permanente y no se puede revertir. ¿Estas de acuerdo en eliminar la ronda?',
    msgDeleteRoundSome:
      'Esta acción es permanente y no se puede revertir. ¿Estas de acuerdo en eliminar las rondas seleccionadas?',
    selected: [],
    singleSelect: true,
    expand: false,
    round: null,
    rounds: [],
    totalRounds: 0,
    working: {
      loading: false,
      wLoading: false,
    },
    pagination: {
      descending: false,
      page: 1,
      rowsPerPage: 25,
      sortBy: 'NAME',
    },
    filters: {
      search: '',
    },
    search: '',
    btnClearFilters: false,

    headers: [
      {
        text: 'Foto',
        align: 'left',
        value: 'img',
        sortable: false,
        style: 'width: 80px; max-width: 80px; min-width: 80px',
      },
      {
        text: 'Nombre',
        align: 'left',
        value: 'NAME',
        sortable: true,
        style: 'width: 200px; max-width: 200px; min-width: 200px',
      },
      {
        text: 'Fecha de creación',
        align: 'left',
        value: 'CREATED_AT',
        sortable: true,
        style: 'width: 175px; max-width: 175px; min-width: 175px',
      },
      {
        text: 'Tipo',
        align: 'left',
        value: 'status',
        sortable: false,
        style: 'width: 200px; max-width: 200px; min-width: 200px',
      },
      {
        text: 'Estado',
        align: 'left',
        value: 'parent.firstName',
        sortable: false,
        style: 'width: 200px; max-width: 200px; min-width: 200px',
      },
      {
        text: 'Tutor',
        value: 'invitations.length',
        align: 'left',
        sortable: false,
        style: 'width: 100%',
      },
      {
        text: 'Alumnos',
        value: '',
        align: 'left',
        sortable: false,
        style: 'width: 120px; max-width: 120px; min-width: 120px',
      },
      {
        text: 'Opciones',
        value: 'actions',
        align: 'left',
        sortable: false,
        style: 'width: 250px; max-width: 250px; min-width: 250px',
      },
    ],
    toast: {
      failed: false,
      success: false,
    },
    modals: {
      confirmDelete: false,
    },
    userPermissions: {},
    possibleUserModulePermissions: {
      WATCH_ROUNDS: 'WATCH_ROUNDS',
      CONFIRM_ROUNDS: 'CONFIRM_ROUNDS',
      DELETE_ROUNDS: 'DELETE_ROUNDS',
      DELETE_ROUNDS_INVITATIONS: 'DELETE_ROUNDS_INVITATIONS',
    },
    description: '',
    idsRounds: null,
  }),
  watch: {
    pagination: {
      handler() {
        this.getRounds()
      },
      deep: true,
    },
    getUser() {
      this.mapPermits()
      if (
        !this.userPermissions[this.possibleUserModulePermissions.WATCH_ROUNDS]
      ) {
        this.toast.failed = true
      } else {
        if (this.rounds.length == 0) {
          this.getRounds()
        }
      }
    },
  },
  methods: {
    async downloadPdf() {
      const params = {
        search: this.filters.search,
        orderType: 'asc',
      }

      const response = await this.$store.dispatch('round/getRoundsPdf', params)

      _genericDownloadFile({
        documentName: 'reporte.pdf',
        blob: response.data,
      })
    },
    async downloadXlsx() {
      const params = {
        search: this.filters.search,
        offset: (this.pagination.page - 1) * this.pagination.rowsPerPage,
        size: this.pagination.rowsPerPage,
      }

      const response = await this.$store.dispatch('round/getRoundsXlsx', params)

      _genericDownloadFile({
        documentName: 'reporte.xlsx',
        blob: response.data,
      })
    },
    toggleAll() {
      if (this.selected.length) this.selected = []
      else this.selected = this.$refs.table.filteredItems.slice()
    },
    deleteRound() {
      this.modals.confirmDelete = true
    },
    onDeleteInvitation(data) {
      this.getRounds()
    },
    onDeleteRound() {
      let enviar = {}
      enviar.roundIds = this.filterIdsRound
      this.$store
        .dispatch('round/deleteRound', {
          enviar,
        })
        .then((response) => {
          this.getRounds()
          this.selected = []
        })
        .catch((e) => {
          console.log(e)
        })
    },
    mapPermits() {
      this.userPermissions = _getUserPermissions({
        getUser: this.getUser,
        possibleUserModulePermissions: this.possibleUserModulePermissions,
      })
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
      this.getRounds()
    },
    getRounds() {
      this.working.loading = true
      this.$store
        .dispatch('round/getRounds', {
          offset: (this.pagination.page - 1) * this.pagination.rowsPerPage,
          size: this.pagination.rowsPerPage,
          search: this.filters.search,
          orderBy: this.pagination.sortBy,
          orderType: this.pagination.descending ? 'DESC' : 'ASC',
        })
        .then((response) => {
          this.working.loading = false
          this.rounds = response.data.data
          this.totalRounds = response.data.total
        })
        .catch((error) => {
          this.working.loading = false
          console.log(error)
        })
    },
    confirmRound(round, flag, description = null) {
      this.working.loading = true
      if (flag) {
        round.status = 'A'
        this.$store
          .dispatch('round/confirmRound', round)
          .then((response) => {
            this.toast.success = true
            this.getRounds()
          })
          .catch((error) => {
            this.working.loading = false
            this.toast.failed = true
          })
      } else {
        round.status = 'C'
        round.description = description
        this.$store
          .dispatch('round/confirmRound', round)
          .then((response) => {
            this.toast.success = true
            this.getRounds()
          })
          .catch((error) => {
            this.working.loading = false
            this.toast.failed = true
          })
      }
    },
    filterSearch(clean) {
      this.btnClearFilters = true

      if (!clean) {
        this.filters.search = this.search ? this.search : ''
      } else {
        this.filters.search = ''
        this.search = ''
        this.getRounds()
        this.btnClearFilters = false
      }
      if (!this.working.wLoading) {
        this.getRounds()
      }
    },
    clearSearch() {
      this.filters.search = ''
      this.getRounds()
    },
  },
  computed: {
    ...mapGetters(['getUser']),
    filterIdsRound() {
      return (this.idsRounds = this.selected.map((round) => {
        return round.id
      }))
    },
  },
}
</script>
<style scoped>
#cancelRound {
  display: inline-block;
}
.sortable_pick {
  cursor: pointer;
}
::v-deep .table-full .v-datatable.v-table > tbody {
  max-height: calc(100vh - 355px);
  min-height: calc(100vh - 355px);
}
::v-deep .v-table__overflow {
  max-height: 47vh;
}
</style>
